import { useState, useEffect, SyntheticEvent } from 'react';
import { useNavigate } from "react-router"
import { useFormik } from "formik";
import { CreateEventInfo } from "@app/data/createEvent/types";
import { initFormValues } from "@pages/makeEvent/types/types";
import { useGetDetailEvent } from '@hooks/useGetDetailEvent.ts';
import { useAppDispatch } from "@app/hooks";
import { setEventMode, setEventType } from '@pages/makeEvent/slice/MakeEventSlice.ts'
import { useEventsTypes } from "@/pages/makeEvent/steps-components/eventType-component/useEventsTypes"
import NavigationPanel from '@/pages/eventEditing/components/navigationComponent/navigationComponent'
import VerticalTabs from '@/pages/eventEditing/components/tabsComponent/tabsComponent'
import TabsComponentMobileView from '@pages/eventEditing/components/tabsComponentMobileView/tabsComponentMobileView.tsx'
import useResize from "@hooks/useResize"
import useCredentials from "@utils/useCredentials"
import s from '@pages/eventEditing/styles.module.css'
import { ToastContainer, toast } from 'react-toastify';

const EventEditing = () => {
	const screenWidth = useResize()
  const mobileSize = 480

	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const currentLocationBits = window.location.href.split('/')
	const eventId = currentLocationBits[currentLocationBits.length - 2]

	const { data: eventData, isLoading: isEventDataLoading } = useGetDetailEvent(eventId);
	const credentials = useCredentials()

	// if user isn't the organizer of this event - navigate him to main page
	useEffect(() => {
		if (isEventDataLoading) {
			return
		}
		// @ts-ignore
		if (credentials.userId !== eventData.organizer_id) {
		  navigate("/")
	  }
	}, [eventData])

  //notification for users
  useEffect(() => {
    toast('Внесите необходимые изменения на всех вкладках, а после нажмите "Применить" на любой из вкладок',
      { type: 'info', autoClose: 10000, position: 'top-center' })
  }, [])

	const { eventTypesList, isLoading: isEventTypesListLoading } = useEventsTypes();
	const getEventTypeId = (eventType) => {
		const eventId = eventTypesList.find(({id, type_name}) => type_name === eventType)?.id
		return eventId
	}
	const getEventModeInfo = (isEventPrivate: boolean) => {
		const label: "Закрытое" | "Открытое" = isEventPrivate ? "Закрытое" : "Открытое"
		return { label, value: isEventPrivate }
	}

	const formik = useFormik<CreateEventInfo>({
		initialValues: initFormValues(),
		onSubmit: () => {},
	})
	// filling Formik and eventSlice with eventData
	useEffect(() => {
		if (eventData) {
			const fieldsNames = eventData ? Object.keys(eventData) : []
			fieldsNames.forEach((name) => formik.setFieldValue(name, eventData[name]))
      
			const eventType = eventData["event_type_name"]
			const eventTypeId = getEventTypeId(eventType)
			formik.setFieldValue('event_type_id', eventTypeId)
			dispatch(setEventType({ label: eventType, value: eventTypeId }))
			dispatch(setEventMode(getEventModeInfo(eventData["is_private"])))
		}
	}, [isEventDataLoading, isEventTypesListLoading])

	const photo = eventData?.["event_photo"]

	return (
		<div className={s.container}>
			<ToastContainer />
			{screenWidth > mobileSize && (<>
				<NavigationPanel text={'Редактирование события'} handleClick={() => navigate(-1)}/>
				<VerticalTabs formik={formik} photo={photo} orgId={eventData?.organizer_id} eventId={eventId} />
			</>)}
			{screenWidth <= mobileSize && (<TabsComponentMobileView handleClickBack={() => navigate(-1)} formik={formik} photo={photo} orgId={eventData?.organizer_id} eventId={eventId}/>)}
		</div>
	)
}

export default EventEditing